import { gql } from "@apollo/client";

export const GET_INDICACIONES_SOLIC_BY_ID_EVALUACION = gql`
  query getIndicacionesSolicitudesByIdEvaluacion($idEvaluacion: Int!) {
    indicacionesSolicitudesByIdEvaluacion(idEvaluacion: $idEvaluacion) {
      success
      error
      valorEsperado {
        idIndicacionAprobacion
        idEvaluacion
        periodo
        fechaAlta
        solicitante
        observacionSolicitante
        idEstadoMedico
        estadoMedico
        idEstadoComercial
        estadoComercial
      }
    }
  }
`;